var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSmLogo = function SvgSmLogo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 211,
    viewBox: "0 0 178 211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 33995"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M172.665 120.221C168.103 128.146 152.847 137.686 141.109 144.482L38.4699 206.691C26.5653 214.401 9.2311 210.101 1.55604 198.707C1.27102 198.278 1.0753 197.797 0.9807 197.291C0.886104 196.785 0.894579 196.266 1.0055 195.763C1.11642 195.261 1.32756 194.786 1.6263 194.367C1.92504 193.948 2.30523 193.593 2.74413 193.325L148.036 105.299L172.665 120.221Z",
    fill: "url(#paint0_radial_418_6786)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M177.084 105.287C177.093 110.59 175.553 115.781 172.653 120.221C116.42 86.1227 58.8693 51.2166 2.7558 17.2254C2.31691 16.9568 1.93671 16.6024 1.63797 16.1834C1.33923 15.7644 1.12809 15.2895 1.01717 14.787C0.90625 14.2845 0.897846 13.7649 0.992443 13.2591C1.08704 12.7533 1.28269 12.2717 1.56771 11.8433C9.23089 0.485175 26.5889 -3.81571 38.4936 3.89499C37.0679 3.02768 68.7305 22.2035 143.651 67.636C159.988 77.5922 177.073 85.5762 177.084 105.287Z",
    fill: "url(#paint1_radial_418_6786)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M38.4694 77.8072C53.6531 77.8072 65.9618 90.1159 65.9618 105.3C65.9618 120.483 53.6531 132.792 38.4694 132.792C23.2858 132.792 10.977 120.483 10.977 105.3C10.977 90.1159 23.2858 77.8072 38.4694 77.8072Z",
    fill: "#7573FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_418_6786",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.0627 203.578) scale(174.34 174.34)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3253D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#413FB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B428C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_418_6786",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-11.3112 68.6697) scale(189.346 189.346)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4F6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#7573FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14BDEB"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSmLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sm-logo.2a40379c0c7f7c183b2d52e8f128f2dd.svg";